// istanbul ignore file
export function unreachable(_: never) {}

export class UnreachableError extends Error {
  constructor(_unreachableItem: never) {
    super(`Unexpected value found at runtime: ${_unreachableItem as string}`);
    this.name = 'UnreachableError';
  }
}
